import React, {useRef} from 'react'
import {PrimeIcons} from "primereact/api";
import {OverlayPanel} from "primereact/overlaypanel";
import {Checkbox} from "primereact/checkbox";

/**
 * Zahnrad oben rechts in den TV-Ansichten (alt und neu): was bei allen Boards angezeigt wird. Den Schalter für den
 * Finishweg gibt es nur, wenn onShowFinish übergeben wird (neue TV-Ansicht).
 */
export default function LiveTVEinstellungen({showBoard, showAverage, showLastThrow, showDarts, showFinish, onShowBoard, onShowAverage, onLastThrow, onShowDarts, onShowFinish}) {

    const einstellungenOP = useRef(null);

    const getEintrag = (id, label, checked, onChange) => {
        return <div style={{display: "flex", alignItems: "center", gap: 10, marginTop: 10}}>
            <Checkbox inputId={id} checked={checked} onChange={() => onChange(!checked)}/>
            <label htmlFor={id} style={{cursor: "pointer"}}>{label}</label>
        </div>
    }

    // inline, damit es in Leisten neben dem Zoom stehen kann
    return <span style={{display: "inline-flex", alignItems: "center"}}>
        <button type="button" aria-label="Einstellungen der TV-Ansicht" title="Einstellungen"
                onClick={(e) => einstellungenOP.current.toggle(e)}
                style={{background: "none", border: 0, padding: 4, color: "white", cursor: "pointer"}}>
            <i className={PrimeIcons.COG} style={{fontSize: 22}}/>
        </button>
        {/* direkt am Zahnrad, damit es auch im echten Vollbild (nur der Vollbild-Bereich ist sichtbar) erscheint */}
        <OverlayPanel ref={einstellungenOP} appendTo="self" showCloseIcon={false} dismissable={true} style={{width: 220}}>
            <div style={{fontWeight: "bold"}}>Anzeige für alle Boards</div>
            {getEintrag("id-livetv-board", "Zeige Board", showBoard, onShowBoard)}
            {getEintrag("id-livetv-last", "Zeige letzten Wurf (Last)", showLastThrow, onLastThrow)}
            {getEintrag("id-livetv-darts", "Zeige Darts", showDarts, onShowDarts)}
            {getEintrag("id-livetv-average", "Zeige Average", showAverage, onShowAverage)}
            {/* den Finishweg gibt es nur in der neuen TV-Ansicht */}
            {onShowFinish && getEintrag("id-livetv-finish", "Zeige Finishweg", showFinish, onShowFinish)}
        </OverlayPanel>
    </span>
}
